module.exports = __webpack_public_path__ + "img/23-2.facbd269.png";